import {
  Directive,
  Input,
  ElementRef,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { TooltipContentComponent } from "./tooltip-content.component";

@Directive({
  selector: "[ionicHoverTooltip]",
})
export class IonicHoverTooltipDirective implements OnDestroy {
  @Input("ionicHoverTooltip") content!: string | Record<string, string>;

  private popover?: HTMLIonPopoverElement;
  private closeTimeout?: any;

  constructor(
  private el: ElementRef<HTMLElement>,
  private popoverCtrl: PopoverController,
) {
  const tag = this.el.nativeElement.tagName?.toLowerCase();

  const isNaturallyFocusable =
    tag === 'input' ||
    tag === 'textarea' ||
    tag === 'select' ||
    tag === 'button' ||
    tag === 'a' ||
    tag === 'ion-input';

  if (!isNaturallyFocusable && !this.el.nativeElement.hasAttribute('tabindex')) {
    this.el.nativeElement.setAttribute('tabindex', '0');
  }
}
  /* 🖱 Mouse users */
  @HostListener("mouseenter", ["$event"])
  onMouseEnter(ev: MouseEvent) {
    clearTimeout(this.closeTimeout);
    this.open(ev);
  }

  @HostListener("mouseleave")
  onMouseLeave() {
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 150);
  }

  /* ⌨ Keyboard users */
  @HostListener("focusin", ["$event"])
  onFocusIn(ev: FocusEvent) {
 
  const tag = this.el.nativeElement.tagName?.toLowerCase();
  if (tag === 'input' || tag === 'ion-input' || tag === 'textarea') {
    return;
  }
  this.open(ev);
}

  @HostListener("focusout")
  onFocusOut() {
    this.close();
  }

  private async open(ev: Event) {
    if (this.popover || !this.content) return;
    this.popover = await this.popoverCtrl.create({
      component: TooltipContentComponent,
      componentProps: {
        content: this.content,
      },
      event: ev,
      side: "top",
      alignment: "center",
      showBackdrop: false,
      cssClass: "ionic-tooltip-popover",
    });

    await this.popover.present();
  }

  private async close() {
    if (this.popover) {
      await this.popover.dismiss();
      this.popover = undefined;
    }
  }

  ngOnDestroy() {
    this.close();
  }
}
